export function communityKeywordPopListGet() {
	return {
    type: 'COMMUNITY_KEYWORD_POP_LIST_GET',
	}
}


export function communityKeywordSearchListGet(word) {
	return {
    type: 'COMMUNITY_KEYWORD_SEARCH_LIST_GET',
		payload: {
			word: word,
		},
	}
}

export function communityKeywordSearchListInit() {
	return {
    type: 'COMMUNITY_KEYWORD_SEARCH_LIST_INIT',
	}
}

export function communityKeywordUserListGet(keyword, page, timestamp) {
	return {
		type: "COMMUNITY_KEYWORD_USER_LIST_GET",
		payload: {
			keyword: keyword,
			page: page,
			timestamp: timestamp,
		},
	}
}

export function communityKeywordUserListInit() {
	return {
		type: "COMMUNITY_KEYWORD_USER_LIST_INIT",
	}
}
